import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { Alert } from 'reactstrap';

const messages = defineMessages({
  scheduledMaintenance: {
    id: 'announcement.scheduledMaintenance',
    defaultMessage: 'Scheduled Maintenance: The customer portal will be unavailable on Wednesday, July 8th, from 10–11pm EST for scheduled maintenance. We’ll be back up shortly after.',
    description: 'Scheduled maintenance announcement shown on the login page',
  },
});

// Dates are in UTC — EDT is UTC-4, EST is UTC-5.
const ANNOUNCEMENTS = [
  {
    id: 'scheduled-maintenance',
    startDate: new Date('2026-07-06T14:00:00Z'), // July 6 10:00 AM EDT
    endDate: new Date('2026-07-09T05:00:00Z'),   // July 9  1:00 AM EDT
    message: messages.scheduledMaintenance,
    color: 'warning',
  },
];

const Announcement = () => {
  const now = new Date();
  const active = ANNOUNCEMENTS.find(
    ({ startDate, endDate }) => now >= startDate && now <= endDate,
  );

  if (!active) return null;

  return (
    <Alert color={active.color} className="mb-3">
      <FormattedMessage {...active.message} />
    </Alert>
  );
};

export default Announcement;
